import { AppstoreOutlined } from '@ant-design/icons';
import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder.ts';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { type IRowWidget } from './IRowWidget.ts';
import { RowWidgetComponent } from './RowWidgetComponent.tsx';
import {
  RowWidgetConfigComponent,
  RowWidgetConfigSchema,
} from './RowWidgetConfigComponent.tsx';
import { renderRowHtml } from './renderRowHtml.ts';

/**
 * Widget di tipo Riga.
 * Mostra gli elementi figli in orizzontale.
 */
export const RowWidgetType: IWidgetType<IRowWidget> = {
  type: WidgetType.Row,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Riga',
  icon: <AppstoreOutlined />,
  hasValue: false,
  formComponent: RowWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);

    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: RowWidgetConfigComponent,
  configValidator: RowWidgetConfigSchema,
  previewComponent: RowWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
  childrenLayoutStrategy: 'horizontal',
  renderHtml: renderRowHtml,
};
